import React from "react";

const UserCreateContext = React.createContext();

export default UserCreateContext;
